import {
  Checkbox,
  FormControlLabel,
  Stack,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditElementTypeMatcher from '../EditableGroupedView/EditElementTypeMatcher';
import { v4 as uuidV4 } from 'uuid';
import { GroupByRadioType } from 'Global/Components/CommonComponents/GroupedView/Functions/GroupByRadioType';
import i18next from 'i18next';

const EditableCustomCheckBox = ({
  label,
  onChange,
  BooleanOutPut = false,
  disabled = false,
  LiftState,
  disableBlock,
  defaultChecked,
  element,
  setValue,
  control,
  errors,
  size,
}) => {
  const [children, setChildren] = useState([]);
  useEffect(() => {
    if (defaultChecked) {
      if (element && element?.members?.length > 0) {
        setChildren(element.members);
      }
    }
  }, [defaultChecked]);

  const isEnglish = i18next.language === 'en';

 
  return (
    <React.Fragment>
      <Stack
        direction="row-reverse"
        justifyContent={
          isEnglish ? 'flex-start' : 'flex-end'
        }
        alignItems="center"
      >
        <FormControlLabel
          sx={{
            width: 'auto',
            marginRight: '0',
            flexDirection: 'row-reverse',
            alignItems: 'center',
            gap: '.5em',
            ...(isEnglish
              ? {}
              : {
                  flexDirection: 'row',
                  '& .MuiFormControlLabel-label': {
                    order: 2,
                  },
                }),
            '::before':
              children?.length > 0
                ? {
                    content: '""',
                    display: 'block',
                    alignSelf: 'right',
                    width: '.1em',
                    height: '2em',
                    backgroundColor: 'black',
                  }
                : {},
          }}
          control={
            <Checkbox
              color="colorPrimer"
              defaultChecked={defaultChecked ?? false}
              disabled={disabled}
              sx={{
                paddingRight: 0,
                paddingBlock: disableBlock ? 0 : {},
                ...(size
                  ? {
                      '& .MuiSvgIcon-root': {
                        fontSize: size,
                      },
                    }
                  : {}),
              }}
              onChange={(event) => {
                LiftState &&
                  LiftState(event.target.checked);
                if (BooleanOutPut && onChange) {
                  onChange(event.target.checked);
                } else {
                  if (onChange) {
                    event.target.checked
                      ? onChange(1)
                      : onChange('');
                  }
                }
                if (
                  element &&
                  element?.members?.length > 0
                ) {
                  if(event.target.checked){
                    setChildren(element.members);
                    onChange(1)
                  }else{
                    setChildren([])
                    onChange('');
                  }
                  
                }
              }}
            />
          }
          label={label}
        />
      </Stack>
      <Stack
        gap=".5em"
        border={
          children?.length > 0 ? '1px solid gainsboro' : ''
        }
        padding={
          children?.length > 0 ? '.5em 1em .5em 1em' : ''
        }
      >
        {children?.length > 0 ? (
          GroupByRadioType(children)?.map((child) => (
            <EditElementTypeMatcher
              field={child}
              onChange={onChange}
              control={control}
              errors={errors}
              setValue={setValue}
              key={uuidV4()}
            />
          ))
        ) : (
          <></>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default EditableCustomCheckBox;
